/**
 * Score colour bands for micro simulation results (decision D12):
 * 75%+ strong, 50–74% developing, under 50% practice focus.
 * Same thresholds as the PDF (backend utils/microSimCharts.js).
 */

const BANDS = {
  strong: { key: 'strong', label: 'Strong', hex: '#10B981', bar: 'bg-emerald-500', soft: 'bg-emerald-50', text: 'text-emerald-700' },
  developing: { key: 'developing', label: 'Developing', hex: '#F59E0B', bar: 'bg-amber-500', soft: 'bg-amber-50', text: 'text-amber-700' },
  focus: { key: 'focus', label: 'Practice focus', hex: '#EF4444', bar: 'bg-red-500', soft: 'bg-red-50', text: 'text-red-700' },
  none: { key: 'none', label: 'Not measured', hex: '#CBD5E1', bar: 'bg-neutral-300', soft: 'bg-neutral-50', text: 'text-neutral-400' },
};

export const bandOf = (score) => {
  if (score === null || score === undefined) return BANDS.none;
  if (score >= 75) return BANDS.strong;
  if (score >= 50) return BANDS.developing;
  return BANDS.focus;
};

/** Band for a share of points (0–1), e.g. one decision's earned ÷ possible. */
export const bandOfRatio = (ratio) => bandOf(ratio === null || ratio === undefined ? null : Math.round(ratio * 100));

export const BandLegend = () => (
  <div className="flex flex-wrap gap-x-3 gap-y-1 text-[11px] text-neutral-500">
    {[BANDS.strong, BANDS.developing, BANDS.focus].map((b) => (
      <span key={b.key} className="inline-flex items-center gap-1">
        <span className={`h-2.5 w-2.5 rounded-sm ${b.bar}`} />
        {b.label}
        {b.key === 'strong' ? ' 75%+' : b.key === 'developing' ? ' 50–74%' : ' <50%'}
      </span>
    ))}
  </div>
);
